<!--
  - Copyright (c) ProviderTrust LLC.
  - All Rights Reserved.
  -
  - This software is confidential and proprietary information of
  - ProviderTrust LLC ("Confidential Information"). You shall not disclose
  - such Confidential Information and shall use it only in
  - accordance with the terms of the license agreement you entered
  - into with ProviderTrust.
  -->

<template>
  <v-card>
    <v-card-title>Any Questions?</v-card-title>
    <v-card-text>
      Chat with us using the chat icon in the lower right corner of your screen
      or
      <a href="" @click.prevent="help"
        >read through our support articles here.</a
      >
    </v-card-text>
    <v-card-text v-if="cancellable">
      <v-dialog
        v-model="accountCancelDialog"
        max-width="500px"
        content-class="app-dialog"
      >
        <a slot="activator">Need to cancel your account?</a>

        <h2>We're sorry to see you go!</h2>

        <p>
          If you decide to cancel your account, access and service will continue
          until your next billing period ({{ nextBillingDate }}) at which time
          your account will be disabled and a charge for the prior billing
          period's monthly fee and activity will process.
        </p>

        <div class="actions">
          <a href="" @click.prevent="accountCancelDialog = false">Never Mind</a>
          <a
            href=""
            @click.prevent="
              accountCancelDialog = false
              $emit('cancel-account')
            "
            >Cancel my Account</a
          >
        </div>
      </v-dialog>
    </v-card-text>
  </v-card>
</template>
<script>
import { launchHelp } from "@/service/zendesk"

export default {
  name: "HelpCard",
  props: {
    nextBillingDate: {
      type: String,
      default: ""
    },
    cancellable: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    accountCancelDialog: false
  }),
  methods: {
    help() {
      launchHelp()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AccountDetailsHelpCard.vue